import { Pipe, PipeTransform } from '@angular/core';
// import * as _ from 'lodash';

@Pipe({
  name: 'unique',
  pure: false
})
export class UniquePipe implements PipeTransform {
  transform(value: any): any {
    if (value !== undefined && value !== null) {
      // return _.uniqBy(value, 'IssuerConCode');
      return value.filter((x, i, a) => x && a.indexOf(x) === i);
      //return value;
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/unique.ts